import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../contexts/auth";
import { ChatMessageType } from "../../../services/apiTypes";
import Message from "../Messages";
import AnswerModal from "../Modals/AnswerModal";
import { ChatBeginText, MessagesContainer } from "./styles";

type ChatProps = {
  username: string;
  messages: ChatMessageType[];
  handleMessageSelection: (message: ChatMessageType) => void;
  selectingMessages: boolean;
  answeringMessage: ChatMessageType | undefined;
  setAnsweringMessage: (message: ChatMessageType | undefined) => void;
}

export default function Chat({
  username,
  messages,
  handleMessageSelection,
  selectingMessages,
  answeringMessage,
  setAnsweringMessage
}: ChatProps) {
  const { user } = useAuth();
  const scrollRef = useRef<any>(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollHeight, setScrollHeight] = useState(0);
  const [oneModalIsOpen, setOneModalIsOpen] = useState<string>("");

  let messagesEnd: any = useRef(null);
  useEffect(() => {
    messagesEnd.scrollIntoView({ behavior: "smooth" });
  }, [messages, answeringMessage]);

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      setScrollHeight(scrollHeight);
      setScrollPosition(scrollTop);
    }
  };

  const handleCloseAnswerModal = () => {
    setAnsweringMessage(undefined);
  };

  return (
    <MessagesContainer ref={scrollRef} onScroll={handleScroll}>
      <ChatBeginText>Início do chat</ChatBeginText>
      {messages && messages.map((message, index) => (
        <>
          {messages[index - 1]?.parentId !== message.parentId &&
            <div style={{ minHeight: 16 }}></div>
          }
          <Message
            scrollPosition={scrollPosition}
            key={message.id}
            message={message}
            sent={user?.userId === message.parentId}
            handleMessageSelection={handleMessageSelection}
            selectingMessages={selectingMessages}
            setAnsweringMessage={setAnsweringMessage}
            scrollHeight={scrollHeight}
            isUserLastMessage={messages[index + 1]?.parentId !== message.parentId}
            oneModalIsOpen={oneModalIsOpen}
            setOneModalIsOpen={setOneModalIsOpen}
          />
        </>
      ))}
      {!!answeringMessage && (
        <AnswerModal
          username={answeringMessage.parentId}
          text={answeringMessage.content}
          onClick={() => handleCloseAnswerModal()}
        />
      )}
      <div style={{ float: "left", clear: "both", minHeight: answeringMessage ? 30 : 32 }}
        ref={(el) => { messagesEnd = el; }}>
      </div>
    </MessagesContainer>
  );
}